import axios from "./axiosInstance";

const RegisterAPI = {
  postRegisterDetails: (params) => axios.post(`/register`,params),
};

export default RegisterAPI;